var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutside.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRef",
          staticClass: "dialog",
          attrs: { role: "dialog", "aria-modal": "true", tabindex: "-1" },
          on: { keydown: _vm.onKeydown },
        },
        [
          _c("div", { staticClass: "dialog__body" }, [
            _c("p", { staticClass: "dialog__message" }, [
              _vm._v(_vm._s(_vm.messageText)),
            ]),
            _vm.phase === "confirm"
              ? _c("p", { staticClass: "dialog__note" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("proofreadingApplyConfirmDialog.note")) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.phase === "applying"
              ? _c(
                  "div",
                  { staticClass: "dialog__loading" },
                  [
                    _c("LoadingSpinner", {
                      attrs: { size: "medium", variant: "inline" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "footer",
            { staticClass: "dialog__footer" },
            [
              _vm.phase === "success"
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "dialog__ok-button",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickSuccessOk },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("proofreadingApplyConfirmDialog.ok")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass: "dialog__cancel-button",
                        attrs: {
                          type: "button",
                          disabled: _vm.phase === "applying",
                        },
                        on: { click: _vm.onClickNo },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("proofreadingApplyConfirmDialog.no")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "dialog__ok-button",
                        attrs: {
                          type: "button",
                          disabled: _vm.phase === "applying",
                        },
                        on: { click: _vm.onClickYes },
                      },
                      [_vm._v(" " + _vm._s(_vm.primaryButtonText) + " ")]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }